import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { usePolling } from "@jti/rest-api";
import { Button } from "../../../components/Button";
import { Icon } from "../../../components/Icon";
import { Loading } from "../../../components/Loading";
import Close from "../../../icons/close.svg";
import { useTranslations } from "../../../providers/useTranslations";
import styles from "./AsyncValidationPopup.module.scss";
export const AsyncValidationPopup = ({ onTryAgain, onCancel, onRefresh, isOpened, isError, }) => {
    const { __ } = useTranslations();
    const { startPolling, stopPolling } = usePolling();
    const mainInformationText = isError
        ? __("ageverification.async_popup.error_message")
        : __("ageverification.async_popup.description");
    const handlePollingAvData = useCallback(() => {
        if (!isOpened || isError) {
            stopPolling();
            return;
        }
        stopPolling(); // clear previous interval to not loose reference to it
        startPolling(onRefresh, 5000);
    }, [isError, isOpened, onRefresh, startPolling, stopPolling]);
    useEffect(() => {
        handlePollingAvData();
        return () => stopPolling();
    }, [handlePollingAvData, stopPolling]);
    if (!isOpened) {
        return null;
    }
    return (_jsx("div", { className: styles.popupWrapper, "data-testid": "async-av-validation-popup", children: _jsxs("div", { className: styles.popupContainer, children: [_jsx("div", { className: styles.headline, children: __("ageverification.async_popup.headline") }), _jsx(Icon, { onClick: onCancel, className: styles.closeIcon, component: Close, width: "15px", height: "15px" }), _jsx("p", { className: styles.popupDescription, children: mainInformationText }), !isError && _jsx(Loading, { dataTestId: "async-av-validation-popup-loading" }), _jsxs("div", { className: styles.popupActionBar, children: [_jsx(Button, { className: styles.actionButton, color: "secondary", onClick: onCancel, disabled: !isError, children: __("ageverification.async_popup.button.cancel") }), _jsx(Button, { className: styles.actionButton, color: "primary", onClick: onTryAgain, isPending: !isError, children: __("ageverification.async_popup.button.try_again") })] })] }) }));
};
//# sourceMappingURL=AsyncValidationPopup.js.map